import {
  RECEIVE_FIELDS,
  RECEIVE_FIELDS_FAILURE,
  RECEIVE_FIELDS_MULTI_OPERATIONS,
  RECEIVE_FIELDS_FAILURE_MULTI_OPERATIONS,
  REQUEST_FIELD_SEARCH_INDEX,
  RECEIVE_FIELD_SEARCH_INDEX,
  FIELD_SEARCH_INDEX_FAILURE,
  SEARCH_FIELDS_BY_NAME,
  RECEIVE_FIELD_NAME_SEARCH_RESULTS,
  CLEAR_FIELD_NAME_SEARCH,
} from '../constants/actionTypes';
import type { FieldSearchIndex } from '../requesters/uapiFieldsRequester/uapiFieldsRequester';

export interface FieldEntry {
  id: string;
  name: string;
  [key: string]: unknown;
}

export interface FieldsState {
  byId: Record<string, FieldEntry>;
  allIds: string[];
  current: string;
  searchIndex: FieldSearchIndex | null;
  nameSearchTerm: string;
  nameSearchResults: FieldSearchIndex | null;
  isNameSearchLoading: boolean;
}

export const initialState: FieldsState = {
  byId: {},
  allIds: [],
  current: '',
  searchIndex: null,
  nameSearchTerm: '',
  nameSearchResults: null,
  isNameSearchLoading: false,
};

type FieldsAction =
  | { type: typeof RECEIVE_FIELDS; payload: FieldEntry[] }
  | { type: typeof RECEIVE_FIELDS_MULTI_OPERATIONS; payload: FieldEntry[] }
  | { type: typeof RECEIVE_FIELDS_FAILURE }
  | { type: typeof RECEIVE_FIELDS_FAILURE_MULTI_OPERATIONS }
  | { type: typeof REQUEST_FIELD_SEARCH_INDEX }
  | { type: typeof RECEIVE_FIELD_SEARCH_INDEX; searchIndex: FieldSearchIndex }
  | { type: typeof FIELD_SEARCH_INDEX_FAILURE }
  | { type: typeof SEARCH_FIELDS_BY_NAME; searchTerm: string }
  | { type: typeof RECEIVE_FIELD_NAME_SEARCH_RESULTS; searchIndex: FieldSearchIndex; searchTerm: string }
  | { type: typeof CLEAR_FIELD_NAME_SEARCH };

function fieldsReducer(state: FieldsState = initialState, action: FieldsAction = {} as FieldsAction): FieldsState {
  switch (action.type) {
    case RECEIVE_FIELDS_MULTI_OPERATIONS:
    case RECEIVE_FIELDS: {
      const newById: Record<string, FieldEntry> = {};
      action.payload.forEach((field: FieldEntry) => {
        newById[field.id] = field;
      });
      const byId = { ...state.byId, ...newById };
      const allIds = Object.keys(byId).sort((field1, field2) => {
        if (byId[field1].name < byId[field2].name) {
          return -1;
        }
        if (byId[field1].name > byId[field2].name) {
          return 1;
        }
        return 0;
      });
      return { ...state, byId, allIds };
    }
    case RECEIVE_FIELDS_FAILURE_MULTI_OPERATIONS:
    case RECEIVE_FIELDS_FAILURE:
      return initialState;
    case REQUEST_FIELD_SEARCH_INDEX:
      return state;
    case RECEIVE_FIELD_SEARCH_INDEX:
      return {
        ...state,
        searchIndex: { ...state.searchIndex, ...action.searchIndex },
      };
    case FIELD_SEARCH_INDEX_FAILURE:
      return state;
    case SEARCH_FIELDS_BY_NAME:
      return {
        ...state,
        nameSearchTerm: action.searchTerm,
        isNameSearchLoading: true,
      };
    case RECEIVE_FIELD_NAME_SEARCH_RESULTS:
      if (action.searchTerm !== state.nameSearchTerm) {
        return state;
      }
      return {
        ...state,
        nameSearchResults: action.searchIndex,
        searchIndex: { ...state.searchIndex, ...action.searchIndex },
        isNameSearchLoading: false,
      };
    case CLEAR_FIELD_NAME_SEARCH:
      return {
        ...state,
        nameSearchTerm: '',
        nameSearchResults: null,
        isNameSearchLoading: false,
      };
    default:
      return state;
  }
}

export default fieldsReducer;
